import { c as _c } from "react/compiler-runtime";
import { AttributeValue } from '../AttributeTypes';
import { ReactElement } from 'react';
import classNames from 'clsx';
import formatAttributeValue from '@spa/lib/formatAttributeValue';
import styles from './specifications-table.component.module.scss';
interface AttributeContent {
  readonly name: string;
  readonly values: ReadonlyArray<AttributeValue>;
  readonly innerValues?: ReadonlyArray<AttributeValue>;
  readonly titles?: ReadonlyArray<string>;
}
export interface ContentTableProps {
  readonly attributeContent: ReadonlyArray<AttributeContent>;
  readonly labelName: string;
  readonly collapse: boolean;
  readonly titles?: ReadonlyArray<string> | null;
}
const SpecificationsTableComponent = t0 => {
  const $ = _c(23);
  const {
    attributeContent,
    labelName,
    collapse,
    titles
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== attributeContent || $[1] !== collapse || $[2] !== labelName || $[3] !== titles) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const visibleAttributeContent = attributeContent.filter(_temp);
      if (visibleAttributeContent.length === 0) {
        t5 = null;
        break bb0;
      }
      t2 = labelName;
      if ($[9] !== collapse) {
        t3 = classNames(styles["specifications-table"], {
          [styles["specifications-table--collapsed"]]: collapse
        });
        $[9] = collapse;
        $[10] = t3;
      } else {
        t3 = $[10];
      }
      if ($[11] !== titles) {
        t4 = titles && titles.length > 0 && <thead><tr className={styles["specifications-table__row"]}>{titles.map(_temp2)}</tr></thead>;
        $[11] = titles;
        $[12] = t4;
      } else {
        t4 = $[12];
      }
      let t6;
      if ($[13] !== labelName || $[14] !== titles) {
        t6 = t7 => {
          const {
            name,
            values: values_0,
            innerValues
          } = t7;
          return <tr key={`${labelName}-${name}`} className={classNames(styles["specifications-table__row"])}><td className={classNames(styles["specifications-table__cell"], styles["specifications-table__cell--first"], {
              "body-bold": !titles
            })}>{name}</td>{values_0.map((value, idx) => {
              const innerValue = innerValues?.[idx];
              return <td key={`${name}-${formatAttributeValue(value)}-${innerValue ? formatAttributeValue(innerValue) : ""}`} className={styles["specifications-table__cell"]}>{formatAttributeValue(value)}{innerValue && ` / ${formatAttributeValue(innerValue)}`}</td>;
            })}</tr>;
        };
        $[13] = labelName;
        $[14] = titles;
        $[15] = t6;
      } else {
        t6 = $[15];
      }
      t1 = visibleAttributeContent.map(t6);
    }
    $[0] = attributeContent;
    $[1] = collapse;
    $[2] = labelName;
    $[3] = titles;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[16] !== t1) {
    t6 = <tbody>{t1}</tbody>;
    $[16] = t1;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t6) {
    t7 = <table aria-label={t2} className={t3}>{t4}{t6}</table>;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
export default SpecificationsTableComponent;
function _temp(t0) {
  const {
    values
  } = t0;
  return values.length > 0;
}
function _temp2(title) {
  return <th key={title} className={`${styles["specifications-table__cell"]} bold`}>{title}</th>;
}